const H2Title = ({ title, className, onClick = () => {} }) => (
  <h2
    onClick={onClick}
    className={`text-[#0189D5] text-[30px] border-[#0189D5] font-bold font-alhpr ${className}`}
  >
    {title}
  </h2>
)

export default H2Title
